import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import * as fileSaver from 'file-saver';
import { Observable } from 'rxjs';

import { DeviceService } from '@bayclubs/ui-core';

@Injectable({
    providedIn: 'root'
})
export class DownloadFileService {
    constructor(private deviceService: DeviceService) { }

    public downloadFile(fileContent: any, fileName: string) {
        if (this.deviceService.isMobile()) {
            const blob = new Blob([fileContent], { type: 'application/octet-stream' });
            const reader = new FileReader();
            reader.onload = () => {
                window.location.href = reader.result as string;
            };
            reader.readAsDataURL(blob);
        } else {
            fileSaver.saveAs(fileContent, fileName);
        }
    }

    public catchDownloadError(err: HttpErrorResponse) {
        // this is because api returns error json but generated typescript package has d.ts for 'Blob'
        // so here error is catched, read and return as HttpErrorResponse for correct global error handling
        const reader: FileReader = new FileReader();
        const obs = new Observable((observer: any) => {
            reader.onloadend = e => {
                observer.error(new HttpErrorResponse({ error: JSON.parse(reader.result as string), status: err.status }));
                observer.complete();
            };
        });

        reader.readAsText(err.error);
        return obs;
    }
}
